import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1600 775"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#i-1782990262__a)",
      d: "M1576 0H24C10.745 0 0 10.745 0 24v727c0 13.255 10.745 24 24 24h1552c13.25 0 24-10.745 24-24V24c0-13.255-10.75-24-24-24"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("radialGradient", {
        id: "i-1782990262__a",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(3284.05 0 0 3051.73 476.95 -103.241)",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          offset: ".12",
          "stop-color": "#e0fffc"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#2fd3c7"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }